import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "card-body p-9 pb-12" }
const _hoisted_5 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_7 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_10 = { class: "menu-item px-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_12 = { class: "card mb-5 mb-xl-10" }
const _hoisted_13 = { class: "card-header" }
const _hoisted_14 = { class: "card-title m-0" }
const _hoisted_15 = { class: "card-toolbar flex-row-fluid justify-content-end gap-5" }
const _hoisted_16 = { class: "card-body p-9 pb-12" }
const _hoisted_17 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_19 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_22 = { class: "menu-item px-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_24 = { class: "card mb-5 mb-xl-10" }
const _hoisted_25 = { class: "card-header" }
const _hoisted_26 = { class: "card-title m-0" }
const _hoisted_27 = { class: "card-toolbar flex-row-fluid justify-content-end gap-5" }
const _hoisted_28 = { class: "card-body p-9 pb-12" }
const _hoisted_29 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_31 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_33 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "menu-item px-3" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 1,
  class: "menu-item px-3"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_40 = { class: "d-flex justify-content-end" }
const _hoisted_41 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_42 = { class: "card-header" }
const _hoisted_43 = { class: "card-title m-0" }
const _hoisted_44 = { class: "card-toolbar flex-row-fluid justify-content-end gap-5" }
const _hoisted_45 = { class: "card-body p-9 pb-12" }
const _hoisted_46 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_48 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_50 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "menu-item px-3" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 1,
  class: "menu-item px-3"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_57 = { class: "d-flex justify-content-end" }
const _hoisted_58 = { class: "card mb-5 mb-xl-10" }
const _hoisted_59 = { class: "card-header" }
const _hoisted_60 = { class: "card-title m-0" }
const _hoisted_61 = { class: "card-toolbar flex-row-fluid justify-content-end gap-5" }
const _hoisted_62 = { class: "card-body p-9 pb-12" }
const _hoisted_63 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_65 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_67 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  key: 1,
  class: "menu-item px-3"
}
const _hoisted_70 = ["onClick"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_72 = { class: "d-flex justify-content-end" }
const _hoisted_73 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_75 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_77 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "menu-item px-3" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = {
  key: 1,
  class: "menu-item px-3"
}
const _hoisted_82 = ["onClick"]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_84 = { class: "d-flex justify-content-end" }
const _hoisted_85 = { class: "card mb-5 mb-xl-10" }
const _hoisted_86 = { class: "card-header" }
const _hoisted_87 = { class: "card-title m-0" }
const _hoisted_88 = { class: "card-toolbar flex-row-fluid justify-content-end gap-5" }
const _hoisted_89 = { class: "card-body p-9 pb-12" }
const _hoisted_90 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_91 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_92 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_94 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_95 = ["onClick"]
const _hoisted_96 = {
  key: 1,
  class: "menu-item px-3"
}
const _hoisted_97 = ["onClick"]
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_99 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactCard = _resolveComponent("ContactCard")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_RegistrationCard = _resolveComponent("RegistrationCard")!
  const _component_WarehouseCard = _resolveComponent("WarehouseCard")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_InventoryCard = _resolveComponent("InventoryCard")!
  const _component_BillingCard = _resolveComponent("BillingCard")!
  const _component_FinancialCard = _resolveComponent("FinancialCard")!
  const _component_TaxCard = _resolveComponent("TaxCard")!
  const _component_ContactEditModal = _resolveComponent("ContactEditModal")!
  const _component_RegistrationEditModal = _resolveComponent("RegistrationEditModal")!
  const _component_BillingEditModal = _resolveComponent("BillingEditModal")!
  const _component_WarehouseEditModal = _resolveComponent("WarehouseEditModal")!
  const _component_InventoryEditModal = _resolveComponent("InventoryEditModal")!
  const _component_FinancialEditModal = _resolveComponent("FinancialEditModal")!
  const _component_TaxEditModal = _resolveComponent("TaxEditModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.baseData.show_contact_identification)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.contactInformation.title")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.isNullData(_ctx.contactView))
              ? (_openBlock(), _createBlock(_component_ContactCard, {
                  key: 0,
                  type: _ctx.getKycCommonTypeParams.entityType,
                  data: _ctx.contactView
                }, {
                  "after-title": _withCtx(() => [
                    (_ctx.contactView.identification.kyc_level)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(_ctx.contactView.identification.kyc_level || "--"), 1))
                      : _createCommentVNode("", true)
                  ]),
                  toolbar: _withCtx(() => [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      (_ctx.buttonShowControl(_ctx.contactView).edit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", {
                              class: "menu-link px-3",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editContactIdentification(_ctx.contactView.id)))
                            }, _toDisplayString(_ctx.$t("kyc.actions.editIdentification")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", {
                          class: "menu-link px-3",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editContactAdditional(_ctx.contactView.id)))
                        }, _toDisplayString(_ctx.$t("kyc.actions.editAdditional")), 1)
                      ]),
                      _hoisted_11
                    ])
                  ]),
                  _: 1
                }, 8, ["type", "data"]))
              : _createCommentVNode("", true),
            (_ctx.isNullData(_ctx.contactView))
              ? (_openBlock(), _createBlock(_component_EmptyData, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ])), [
          [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Contact]]
        ])
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.registrationInformation.title")), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_ctx.isNullData(_ctx.registrationView))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-light-primary",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addRegistration && _ctx.addRegistration(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.add")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (!_ctx.isNullData(_ctx.registrationView))
          ? (_openBlock(), _createBlock(_component_RegistrationCard, {
              key: 0,
              type: _ctx.getKycCommonTypeParams.entityType,
              data: _ctx.registrationView
            }, {
              "after-title": _withCtx(() => [
                (_ctx.registrationView.identification.kyc_level)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(_ctx.registrationView.identification.kyc_level || "--"), 1))
                  : _createCommentVNode("", true)
              ]),
              toolbar: _withCtx(() => [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  (_ctx.buttonShowControl(_ctx.registrationView).edit)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", {
                          class: "menu-link px-3",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editRegistrationIdentification(_ctx.registrationView.id)))
                        }, _toDisplayString(_ctx.$t("kyc.actions.editIdentification")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", {
                      class: "menu-link px-3",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editRegistrationAdditional(_ctx.registrationView.id)))
                    }, _toDisplayString(_ctx.$t("kyc.actions.editAdditional")), 1)
                  ]),
                  _hoisted_23
                ])
              ]),
              _: 1
            }, 8, ["type", "data"]))
          : _createCommentVNode("", true),
        (_ctx.isNullData(_ctx.registrationView))
          ? (_openBlock(), _createBlock(_component_EmptyData, { key: 1 }))
          : _createCommentVNode("", true)
      ])
    ])), [
      [_directive_loading, 
        _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Registration]
      ]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.warehouseInformation.title")), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          (_ctx.buttonShowControl(null, _ctx.warehousePagination.total).add)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-light-primary",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addWarehouse && _ctx.addWarehouse(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.add")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouseList, (item, index) => {
          return (_openBlock(), _createBlock(_component_WarehouseCard, {
            key: index,
            type: _ctx.getKycCommonTypeParams.entityType,
            data: item,
            index: 
            index +
            (_ctx.warehousePagination.page - 1) * _ctx.warehousePagination.rowsPerPage
          
          }, {
            "after-title": _withCtx(() => [
              (item.identification.kyc_level)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                : _createCommentVNode("", true)
            ]),
            toolbar: _withCtx(() => [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                (_ctx.buttonShowControl(item).edit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", {
                        class: "menu-link px-3",
                        onClick: ($event: any) => (_ctx.editWarehouseIdentification(item.id))
                      }, _toDisplayString(_ctx.$t("kyc.actions.editIdentification")), 9, _hoisted_34)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", {
                    class: "menu-link px-3",
                    onClick: ($event: any) => (_ctx.editWarehouseAdditional(item.id))
                  }, _toDisplayString(_ctx.$t("kyc.actions.editAdditional")), 9, _hoisted_36)
                ]),
                (_ctx.buttonShowControl(item).deactivate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("div", {
                        class: "menu-link px-3",
                        onClick: ($event: any) => (
                    _ctx.onDeactivateButtonClick(
                      _ctx.CardComponentsType.Warehouse,
                      item.id
                    )
                  )
                      }, _toDisplayString(_ctx.$t("kyc.actions.deactivate")), 9, _hoisted_38)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_39
              ])
            ]),
            _: 2
          }, 1032, ["type", "data", "index"]))
        }), 128)),
        _createElementVNode("div", _hoisted_40, [
          _createVNode(_component_el_pagination, {
            "current-page": _ctx.warehousePagination.page,
            "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.warehousePagination.page) = $event)),
            onCurrentChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Warehouse))),
            "page-size": _ctx.warehousePagination.rowsPerPage,
            "pager-count": 5,
            layout: "prev, pager, next",
            total: _ctx.warehousePagination.total,
            "hide-on-single-page": true,
            background: ""
          }, null, 8, ["current-page", "page-size", "total"])
        ]),
        (_ctx.warehouseList.length === 0)
          ? (_openBlock(), _createBlock(_component_EmptyData, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])), [
      [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Warehouse]]
    ]),
    (_ctx.getKycCommonTypeParams.entityType === _ctx.KycType.Natural)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.inventoryInformation.title")), 1)
            ]),
            _createElementVNode("div", _hoisted_44, [
              (_ctx.buttonShowControl(null, _ctx.inventoryPagination.total).add)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-light-primary",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addInventory && _ctx.addInventory(...args)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.add")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inventoryList, (item, index) => {
              return (_openBlock(), _createBlock(_component_InventoryCard, {
                key: index,
                type: _ctx.getKycCommonTypeParams.entityType,
                data: item,
                index: 
            index +
            (_ctx.inventoryPagination.page - 1) * _ctx.inventoryPagination.rowsPerPage
          
              }, {
                "after-title": _withCtx(() => [
                  (item.identification.kyc_level)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                    : _createCommentVNode("", true)
                ]),
                toolbar: _withCtx(() => [
                  _hoisted_47,
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    (_ctx.buttonShowControl(item).edit)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("div", {
                            class: "menu-link px-3",
                            onClick: ($event: any) => (_ctx.editInventoryIdentification(item.id))
                          }, _toDisplayString(_ctx.$t("kyc.actions.editIdentification")), 9, _hoisted_51)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", {
                        class: "menu-link px-3",
                        onClick: ($event: any) => (_ctx.editInventoryAdditional(item.id))
                      }, _toDisplayString(_ctx.$t("kyc.actions.editAdditional")), 9, _hoisted_53)
                    ]),
                    (_ctx.buttonShowControl(item).deactivate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createElementVNode("div", {
                            class: "menu-link px-3",
                            onClick: ($event: any) => (
                    _ctx.onDeactivateButtonClick(
                      _ctx.CardComponentsType.Inventory,
                      item.id
                    )
                  )
                          }, _toDisplayString(_ctx.$t("kyc.actions.deactivate")), 9, _hoisted_55)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_56
                  ])
                ]),
                _: 2
              }, 1032, ["type", "data", "index"]))
            }), 128)),
            _createElementVNode("div", _hoisted_57, [
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.inventoryPagination.page,
                "onUpdate:current-page": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inventoryPagination.page) = $event)),
                onCurrentChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Inventory))),
                "page-size": _ctx.inventoryPagination.rowsPerPage,
                "pager-count": 5,
                layout: "prev, pager, next",
                total: _ctx.inventoryPagination.total,
                "hide-on-single-page": true,
                background: ""
              }, null, 8, ["current-page", "page-size", "total"])
            ]),
            (_ctx.inventoryList.length === 0)
              ? (_openBlock(), _createBlock(_component_EmptyData, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])), [
          [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Inventory]]
        ])
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.financialInformation.title")), 1)
        ]),
        _createElementVNode("div", _hoisted_61, [
          (_ctx.buttonShowControl(null, _ctx.billingPagination.total).add)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-light",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addBilling && _ctx.addBilling(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("kyc.actions.addBillingAddress")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.buttonShowControl(null, _ctx.financialPagination.total).add)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-light-primary",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.addFinancial && _ctx.addFinancial(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("kyc.actions.addFinancialAccount")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_62, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billingList, (item, index) => {
          return (_openBlock(), _createBlock(_component_BillingCard, {
            key: index,
            type: _ctx.getKycCommonTypeParams.entityType,
            data: item,
            index: 
            index + (_ctx.billingPagination.page - 1) * _ctx.billingPagination.rowsPerPage
          
          }, {
            "after-title": _withCtx(() => [
              (item.identification.kyc_level)
                ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                : _createCommentVNode("", true)
            ]),
            toolbar: _withCtx(() => [
              _hoisted_64,
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                (_ctx.buttonShowControl(item).edit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createElementVNode("div", {
                        class: "menu-link px-3",
                        onClick: ($event: any) => (_ctx.editBilling(item.id))
                      }, _toDisplayString(_ctx.$t("common.edit")), 9, _hoisted_68)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.buttonShowControl(item).deactivate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                      _createElementVNode("div", {
                        class: "menu-link px-3",
                        onClick: ($event: any) => (
                    _ctx.onDeactivateButtonClick(_ctx.CardComponentsType.Billing, item.id)
                  )
                      }, _toDisplayString(_ctx.$t("kyc.actions.deactivate")), 9, _hoisted_70)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_71
              ])
            ]),
            _: 2
          }, 1032, ["type", "data", "index"]))
        }), 128)),
        _createElementVNode("div", _hoisted_72, [
          _createVNode(_component_el_pagination, {
            "current-page": _ctx.billingPagination.page,
            "onUpdate:current-page": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.billingPagination.page) = $event)),
            onCurrentChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Billing))),
            "page-size": _ctx.billingPagination.rowsPerPage,
            "pager-count": 5,
            layout: "prev, pager, next",
            total: _ctx.billingPagination.total,
            "hide-on-single-page": true,
            background: ""
          }, null, 8, ["current-page", "page-size", "total"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.financialList, (item, index) => {
          return (_openBlock(), _createBlock(_component_FinancialCard, {
            key: index,
            type: _ctx.getKycCommonTypeParams.entityType,
            data: item,
            index: 
            index +
            (_ctx.financialPagination.page - 1) * _ctx.financialPagination.rowsPerPage
          
          }, {
            "after-title": _withCtx(() => [
              (item.identification.kyc_level)
                ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                : _createCommentVNode("", true)
            ]),
            toolbar: _withCtx(() => [
              _hoisted_74,
              _createElementVNode("div", _hoisted_75, [
                _hoisted_76,
                (_ctx.buttonShowControl(item).edit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                      _createElementVNode("div", {
                        class: "menu-link px-3",
                        onClick: ($event: any) => (_ctx.editFinancialIdentification(item.id))
                      }, _toDisplayString(_ctx.$t("kyc.actions.editIdentification")), 9, _hoisted_78)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", {
                    class: "menu-link px-3",
                    onClick: ($event: any) => (_ctx.editFinancialAdditional(item.id))
                  }, _toDisplayString(_ctx.$t("kyc.actions.editAdditional")), 9, _hoisted_80)
                ]),
                (_ctx.buttonShowControl(item).deactivate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _createElementVNode("div", {
                        class: "menu-link px-3",
                        onClick: ($event: any) => (
                    _ctx.onDeactivateButtonClick(
                      _ctx.CardComponentsType.Financial,
                      item.id
                    )
                  )
                      }, _toDisplayString(_ctx.$t("kyc.actions.deactivate")), 9, _hoisted_82)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_83
              ])
            ]),
            _: 2
          }, 1032, ["type", "data", "index"]))
        }), 128)),
        _createElementVNode("div", _hoisted_84, [
          _createVNode(_component_el_pagination, {
            "current-page": _ctx.financialPagination.page,
            "onUpdate:current-page": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.financialPagination.page) = $event)),
            onCurrentChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Financial))),
            "page-size": _ctx.financialPagination.rowsPerPage,
            "pager-count": 5,
            layout: "prev, pager, next",
            total: _ctx.financialPagination.total,
            "hide-on-single-page": true,
            background: ""
          }, null, 8, ["current-page", "page-size", "total"])
        ]),
        (_ctx.billingList.length === 0 && _ctx.financialList.length === 0)
          ? (_openBlock(), _createBlock(_component_EmptyData, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])), [
      [_directive_loading, 
        _ctx.loading ||
        _ctx.cardComponentsLoading[_ctx.CardComponentsType.Billing] ||
        _ctx.cardComponentsLoading[_ctx.CardComponentsType.Financial]
      ]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_85, [
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.taxInformation.title")), 1)
        ]),
        _createElementVNode("div", _hoisted_88, [
          (_ctx.buttonShowControl(null, _ctx.taxPagination.total).add)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-light-primary",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addTax && _ctx.addTax(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.add")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_89, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxList, (item, index) => {
          return (_openBlock(), _createBlock(_component_TaxCard, {
            key: index,
            type: _ctx.getKycCommonTypeParams.entityType,
            data: item,
            index: index + (_ctx.taxPagination.page - 1) * _ctx.taxPagination.rowsPerPage
          }, {
            "after-title": _withCtx(() => [
              (item.identification.kyc_level)
                ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                : _createCommentVNode("", true)
            ]),
            toolbar: _withCtx(() => [
              _hoisted_91,
              _createElementVNode("div", _hoisted_92, [
                _hoisted_93,
                (_ctx.buttonShowControl(item).edit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                      _createElementVNode("div", {
                        class: "menu-link px-3",
                        onClick: ($event: any) => (_ctx.editTax(item.id))
                      }, _toDisplayString(_ctx.$t("common.edit")), 9, _hoisted_95)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.buttonShowControl(item).deactivate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                      _createElementVNode("div", {
                        class: "menu-link px-3",
                        onClick: ($event: any) => (
                    _ctx.onDeactivateButtonClick(_ctx.CardComponentsType.Tax, item.id)
                  )
                      }, _toDisplayString(_ctx.$t("kyc.actions.deactivate")), 9, _hoisted_97)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_98
              ])
            ]),
            _: 2
          }, 1032, ["type", "data", "index"]))
        }), 128)),
        _createElementVNode("div", _hoisted_99, [
          _createVNode(_component_el_pagination, {
            "current-page": _ctx.taxPagination.page,
            "onUpdate:current-page": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.taxPagination.page) = $event)),
            onCurrentChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Tax))),
            "page-size": _ctx.taxPagination.rowsPerPage,
            "pager-count": 5,
            layout: "prev, pager, next",
            total: _ctx.taxPagination.total,
            "hide-on-single-page": true,
            background: ""
          }, null, 8, ["current-page", "page-size", "total"])
        ]),
        (_ctx.taxList.length === 0)
          ? (_openBlock(), _createBlock(_component_EmptyData, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])), [
      [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Tax]]
    ]),
    _createVNode(_component_ContactEditModal, {
      ref: "contactEditModal",
      type: _ctx.getKycCommonTypeParams.entityType,
      id: Number(_ctx.contactEditId),
      "update-section": _ctx.updateSection.contact,
      onUpdateInfo: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Contact)))
    }, null, 8, ["type", "id", "update-section"]),
    _createVNode(_component_RegistrationEditModal, {
      ref: "registrationEditModal",
      type: _ctx.getKycCommonTypeParams.entityType,
      id: Number(_ctx.registrationEditId),
      "update-section": _ctx.updateSection.registration,
      onUpdateInfo: _cache[21] || (_cache[21] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Registration)))
    }, null, 8, ["type", "id", "update-section"]),
    _createVNode(_component_BillingEditModal, {
      ref: "billingEditModal",
      type: _ctx.getKycCommonTypeParams.entityType,
      id: Number(_ctx.billingEditId),
      onUpdateInfo: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Billing)))
    }, null, 8, ["type", "id"]),
    _createVNode(_component_WarehouseEditModal, {
      ref: "warehouseEditModal",
      type: _ctx.getKycCommonTypeParams.entityType,
      id: Number(_ctx.warehouseEditId),
      "update-section": _ctx.updateSection.warehouse,
      onUpdateInfo: _cache[23] || (_cache[23] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Warehouse)))
    }, null, 8, ["type", "id", "update-section"]),
    _createVNode(_component_InventoryEditModal, {
      ref: "inventoryEditModal",
      type: _ctx.getKycCommonTypeParams.entityType,
      id: Number(_ctx.inventoryEditId),
      "update-section": _ctx.updateSection.inventory,
      onUpdateInfo: _cache[24] || (_cache[24] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Inventory)))
    }, null, 8, ["type", "id", "update-section"]),
    _createVNode(_component_FinancialEditModal, {
      ref: "financialEditModal",
      type: _ctx.getKycCommonTypeParams.entityType,
      id: Number(_ctx.financialEditId),
      "update-section": _ctx.updateSection.financial,
      onUpdateInfo: _cache[25] || (_cache[25] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Financial)))
    }, null, 8, ["type", "id", "update-section"]),
    _createVNode(_component_TaxEditModal, {
      ref: "taxEditModal",
      type: _ctx.getKycCommonTypeParams.entityType,
      id: Number(_ctx.taxEditId),
      onUpdateInfo: _cache[26] || (_cache[26] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Tax)))
    }, null, 8, ["type", "id"])
  ]))
}